import { lodashPlugin } from '@/utils/plugins/lodash'
import VueTour from '@globalhive/vuejs-tour'

export default function registerGlobalPlugins (app) {
  app.use(lodashPlugin)
  app.use(VueTour)
  app.provide('$window', window)
  app.provide('$document', document)
}
